let productList = [
  // 自助点餐
  [
    {
      isReverse: false,
      title: ['付帅云收银 手机就是收银机'],
      h4: [
        '一个软件，搞定一键微信、支付宝收款，',
        '搞定商品入库定价，搞定扫码算账结账，',
        '手机，就是收银机。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_a_01.png'
    },
    {
      isReverse: true,
      title: ['一键快捷收款'],
      h4: [
        '微信、支付宝、信用卡、花呗付款通通',
        '支持，不用问付款方式，一扫就收。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_a_02.png'
    },
    {
      isReverse: false,
      title: ['防抹零，无损失'],
      h4: [
        '商家自主输入金额，防止客户故意抹零少',
        '付钱。一分一毫都收到，用到就是省到。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_a_03.png'
    },
    {
      isReverse: true,
      title: ['快速商品入库'],
      h4: [
        '扫描商品，自动识别商品，',
        '自动入库，立即可售'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_a_04.png'
    },
    {
      isReverse: false,
      title: ['扫码添加，一键收款'],
      h4: [
        '扫描商品加入购物车，自动统计，一键',
        '扫码收款。条码商品、码损商品、无码',
        '商品，通通支持。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_a_05.png'
    },
    {
      isReverse: true,
      title: ['数据统计分析'],
      h4: [
        '收款笔数、收款金额、分店统计，',
        '各种营业统计数据，应有尽有。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_a_06.png'
    },
    {
      isReverse: false,
      title: ['丰富外设，收银更轻松'],
      h4: [
        '收款自动打印小票，收款实时语音播报，',
        '更多外设，收银更轻松。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_a_07.png'
    }
  ],
  // 自助点餐
  [
    {
      isReverse: false,
      title: ['付帅点餐宝 成倍提高翻台率'],
      h4: [
        '客户自助点餐，在线支付，后厨分单打印，',
        '多窗口独立出菜。用人成本减半，翻台率',
        '翻倍。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_b_01.png'
    },
    {
      isReverse: true,
      title: ['小程序自助点餐'],
      h4: [
        '客户在小程序自助点餐，服务员不用等。',
        '腾出时间，做更好的客户服务。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_b_02.png'
    },
    {
      isReverse: false,
      title: ['在线支付，不用找零'],
      h4: [
        '点餐完成，自助在线支付，效率翻倍。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_b_03.png'
    },
    {
      isReverse: true,
      title: ['后厨自动分单打印'],
      h4: [
        '有多个厨房窗口分别出菜？没问题！后厨',
        '自动分单打印，多窗口独立出菜，更方便！'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_b_04.png'
    },
    {
      isReverse: false,
      title: ['数据统计分析'],
      h4: [
        '收款笔数、收款金额、分店统计，各种营业统计数据，',
        '应有尽有。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_b_05.png'
    },
    {
      isReverse: true,
      title: ['丰富外设，收银更轻松'],
      h4: [
        '收款自动打印小票，收款实时语音播报，',
        '更多外设，收银更轻松'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_b_06.png'
    },
  ],
  // 自主外卖
  [
    {
      isReverse: false,
      title: [
        '付帅云店',
        ' 把到店的生意做到线上五公里'
      ],
      h4: [
        '客户在线点餐，在线支付，',
        '后厨分单打印，多窗口独立出菜。',
        '不用承受高佣金，品牌就是你的生命力。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_c_01.png'
    },
    {
      isReverse: true,
      title: ['线上小程序点餐'],
      h4: [
        '客户线上小程序自助点餐，覆盖周边五公里。',
        '为你，找到更多粉丝和生意。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_c_02.png'
    },
    {
      isReverse: false,
      title: ['自己品牌，拒绝高抽佣'],
      h4: [
        '某平台高达20%佣金？活动一停就没流量？',
        '亏本做活动没钱赚？不能任人宰割。',
        '建立自己品牌，才能自己说了算。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_c_03.png'
    },
    {
      isReverse: true,
      title: ['后厨自动分单打印'],
      h4: [
        '有多个厨房窗口分别出菜？没问题！后厨',
        '自动分单打印，多窗口独立出菜，更方便！'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_c_04.png'
    },
    {
      isReverse: false,
      title: ['专业配送，不用请人'],
      h4: [
        '软件已对接专业外送平台，客户下单，',
        '配送员自动到店，让你配送无忧。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_c_05.png'
    },
    {
      isReverse: true,
      title: ['数据统计分析'],
      h4: [
        '收款笔数、收款金额，',
        '各种营业统计数据，应有尽有。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_c_06.png'
    },
    {
      isReverse: false,
      title: ['各种营业统计数据，应有尽有。'],
      h4: [
        '客户不用下载，附近小程序、二维码、小程序列表，',
        '都是你的流量入口。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_c_07.png'
    },
  ],
  // 扫码购
  [
    {
      isReverse: false,
      title: [
        '付帅扫码购',
        ' 你的导购+服务员+收银员'
      ],
      h4: [
        '客户扫条形码加购，在线查看更多商品详情，',
        '在线微信支付，出场智能核验。',
        '让客户，购物前所未有的轻松。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_d_01.png'
    },
    {
      isReverse: true,
      title: ['扫条码，知道更多'],
      h4: [
        '客户扫描商品条码，了解更详细商品信息。',
        '成交更容易。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_d_02.png'
    },
    {
      isReverse: false,
      title: ['自助加购，微信支付'],
      h4: [
        '顾客扫码加入购物车，系统自动计算价格，',
        '微信支付，成交如此轻松。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_d_03.png'
    },
    {
      isReverse: true,
      title: ['智能核验，轻松离场'],
      h4: [
        '扫码智能核验，打印机自动打印小票，',
        '轻松离场。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_d_04.png'
    },
    {
      isReverse: false,
      title: ['数据统计分析'],
      h4: [
        '收款笔数、收款金额、分店统计，',
        '各种营业统计数据，应有尽有。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_d_05.png'
    },
    {
      isReverse: true,
      title: ['商品管理，从未如此轻松'],
      h4: [
        '商品自动识别，集成商品管理模块，',
        '轻松管理，轻松使用。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/software/soft_d_06.png'
    },
  ],
]

export default productList



// WEBPACK FOOTER //
// ./src/assets/conf/software.js